module.exports = __webpack_public_path__ + "img/line-qrcode@2x.bf954f9f.jpg";